import { render, staticRenderFns } from "./bonus-navbar-button.vue?vue&type=template&id=b94a496a&scoped=true&"
import script from "./bonus-navbar-button.vue?vue&type=script&lang=ts&"
export * from "./bonus-navbar-button.vue?vue&type=script&lang=ts&"
import style0 from "./bonus-navbar-button.vue?vue&type=style&index=0&id=b94a496a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_wzvh6gi4tchptuexh7cjhim74e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94a496a",
  null
  
)

export default component.exports